import Lazyload from 'vanilla-lazyload';
import {debounce} from 'lodash';
import NavItem from '../components/NavItem';

require('image-map-resizer');

let tallest = 0;
let $titles = false;

const setTitleHeights = () => {
  $titles.css('height', tallest);
};

const calculateHeights = () => {
  // reset our height to auto, then get
  // the tallest of the bunch so we can
  // set the height on the other elements.
  $titles.css('height', 'auto');

  let heights = $titles.map(function () {
    return $(this).outerHeight();
  });

  tallest = Math.max(...heights);

  setTitleHeights();
};

const mapPopups = () => {
  $('area[href*=jpg]').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    },
    mainClass: 'interactive-map-popup',
  });
};

const staffPopups = () => {
  $('.team-member__bio').magnificPopup({
    type: 'inline',
    gallery: {
      enabled: true
    },
    mainClass: 'member-popup-lightbox'
  });
};

/**
 * Initialize our carousels using the 'slick-carousel' jQuery plugin.
 * The `.slick-carousel` elements are "dumb" sliders – they only
 * work for image-based sliders. No fancy div-based slides;
 * just put images in there and It Just Works(tm) using
 * the default settings as specified in the plugin.
 *
 * @return {undefined}
 */
const carousels = () => {
  $('.slick-carousel').each(function() {
    let $this = $(this);
    let opts = {};
    let data = $this.data();

    opts.autoplay = !! data.autoplay;
    opts.autoplaySpeed = opts.autoplay && data.autoplaySpeed ? data.autoplaySpeed : 0;
    opts.lazyLoad = !! data.lazyloadType ? data.lazyloadType : 'ondemand';

    $this.slick(opts);
  });
};

const hammerNav = () => {
  [].slice.call(document.querySelectorAll('.nav-item--primary-navigation > a')).forEach(function(element) {
    new NavItem(element);
  });
};

const accordions = () => {
  $('.am-accordion-toggle').click(function() {
    $(this).next('.am-accordion-body').slideToggle();
  });
};

const responsiveImageMaps = () => {
  // $(window).load(function() {
    // ImageMap('img[usemap]');
  // });

  $('map').imageMapResize();
};

const galleryPopups = () => {
  $('.am-gallery-img > a, a.am-gallery-img').magnificPopup({
    type: 'image',
    gallery: { enabled: true },
  });
};

const mailingListForm = () => {
  localStorage.clear();
  let $window = $(window);
  let $topGap = parseInt($('html').css('margin-top'));
  let $body = $('body');
  let $form = $('#ml-form');
  let $closeBtn = $('.close-ml-form');
  let $buffer = 200;
  var $target = $window.innerHeight() + $form.outerHeight() + $buffer;
  var formClosed = localStorage.getItem('formClosed');

  function closeForm() {
      localStorage.setItem('formClosed', true);
      $body.removeClass('show-ml-form');
  }

  function stickUnstick() {
      if ($window.scrollTop() + $window.innerHeight() >= $target + $topGap) {
          if (!$form.hasClass('ml-form-stuck')) {
              $form.addClass('ml-form-stuck');
              $form.css('bottom', 0);
          }
      } else {
          var $targetBottom = document.body.offsetHeight - $target + 'px';
          if ($form.hasClass('ml-form-stuck')) $form.removeClass('ml-form-stuck');
          if ($form.css('bottom') !== $targetBottom) $form.css('bottom', $targetBottom);
      }
  }

  if (!formClosed) {
      $closeBtn.on('click', closeForm);

      $window.on('load', function() {
        setTimeout(function() {
          $body.addClass('show-ml-form');
        }, 10);

        $target = $window.innerHeight() + $form.outerHeight() + $buffer;

        setTimeout(stickUnstick, 10);
      });

      $window.on('scroll', function() {
          stickUnstick();
      });
  }
}

export default {
  init() {
    // JavaScript to be fired on all pages
    accordions();
  },
  finalize() {
    $titles = $('.service__title');

    mapPopups();

    // Gallery layout
    galleryPopups();

    // Team member layouts - handle popups.
    staffPopups();

    calculateHeights();

    // initialize our carousels across the site.
    carousels();

    // Initialize hammer.js stuff.
    hammerNav();

    // Responsive image maps for any image that uses a <map> element.
    responsiveImageMaps();

    $(window).resize(debounce(calculateHeights, 100));

    mailingListForm();

    document.body.classList.remove('no-js');
    // JavaScript to be fired on all pages, after page specific JS is fired
    window.Lazyload = new Lazyload({
      elements_selector: '[data-original], [data-original-set], [data-src], [data-src-set]',
    });

    $('.down-arrow').click(function () {
      let $this = $(this);
      let $parent = $this.closest('section');

      let scrollTop = $parent.offset().top + $parent.outerHeight();

      $('body, html').animate({scrollTop}, 1000);
    });

    $('.am-gallery-wrap').magnificPopup({
  		delegate: 'a',
  		type: 'image',
  		tLoading: 'Loading image #%curr%...',
  		gallery: {
  			enabled: true,
  			navigateByImgClick: true,
  			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  		},
  		image: {
  			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
  		}
  	});

  },
};

$(window).on('load', function() {
  $('.am-gallery-wrap').masonry({
      itemSelector: '.am-gallery-img'
  });
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js